import React from 'react'
import { Box } from '@mui/material'
import ColorBox from 'common/Box/ColorWhiteBox'
import PageLayoutV2 from 'common/Layout/Page/PageLayoutV2'

import FinanceTable from '../components/FinanceTable'

function FinanceMainDashboard() {
  return (
    <PageLayoutV2 header='Finance'>
      <ColorBox>
        <Box>
          <FinanceTable />
        </Box>
      </ColorBox>
    </PageLayoutV2>
  )
}

export default FinanceMainDashboard
